export const pluralForms = {
  chapter: ['chapter of theory', 'chapters of theory', 'chapters of theory'],
  question: ['tests question', 'tests questions', 'tests questions'],
  flashcardsDeck: ['flashcards deck', 'flashcards decks', 'flashcards decks'],
  mnemonicCardsDeck: ['mnemonic cards deck', 'mnemonic cards decks', 'mnemonic cards decks'],
  days: ['day', 'days', 'days'],
};
